export default __webpack_public_path__ + "static/media/project-visualization.9225a70d.png";